import type { FunctionPlugin } from 'vue';
import type { Router, RouteRecordRaw } from 'vue-router';

import type { SoaConfig } from '@/core/lib/Config';

interface DomainOptions {
  router: Router;
  config: SoaConfig;
}

export function domainFactory(routes?: readonly RouteRecordRaw[]): FunctionPlugin<DomainOptions> {
  return function (app, options?: DomainOptions) {
    if (options === undefined) {
      throw new TypeError('Domain options required.');
    }

    const { router } = options;

    // Expose domain routes to the common router
    if (routes) {
      routes.forEach(route => {
        router.addRoute(route);
      });
    }
  };
}
